import React, { useEffect, useState } from "react"
import { MenuAdmin } from "./MenuAdmin"
import { Header } from "../common/header/Header"
import { IMG } from "../common/CONST"
import { AdminQuickActions } from "./AdminQuickActions"
import { Brockman } from "./Brockman"
import * as TrinityAPI from "../../requests/TrinityAPI"
import { IUpdateProfileDto } from "../../types/user/IUpdateProfileDto"
import { ModalPopUp } from "../common/element/ModalPopUp"
import { IModalMessage } from "../../types/error/IModalMessage"
import { useStore } from "../../stores/RootStoreContext"

export const AdminDashboard = () => {
  const [profile, setProfile] = useState<IUpdateProfileDto>()
  const [modalMessage, setModalMessage] = useState<IModalMessage | null>(null)
  const { userStore } = useStore()

  useEffect(() => {
    TrinityAPI.getProfile(response => {
      if (response.status === 200) {
        setProfile(response.data)
      } else {
        setModalMessage({ title: "Ошибка!", text: "Ошибка получения профиля: " + response.data.message })
      }
    })
  }, [])

  return (
    <>
      <ModalPopUp message={modalMessage} close={() => setModalMessage(null)} />
      <MenuAdmin active={"dashboard"} />
      <main className="main-container">
        <Header />

        <div className="container">
          <h1 className="ui-heading">Главная</h1>
          <div className="profile-block">
            <img src={IMG.main_logo} alt="" className="avatar-img" />
            <div className="profile-block-about">
              <h4 className="profile-name">{profile?.name}</h4>
              <p className="main-header-item-text">{userStore.getUser.username}</p>
            </div>
          </div>

          <AdminQuickActions />
          <Brockman />
        </div>
      </main>
    </>
  )
}
